import React, { useEffect, useState } from "react";
import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Typography,
    Box,
    TextField,
    Button,
    Chip,
    Stack,
} from "@mui/material";
import { getIOTDetections } from "../../api/api";

const DetectionSelection = ({ selectedSensors, setDetections }) => {
    const [detections, setDetectionsList] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedDetections, setSelectedDetections] = useState([]);

    useEffect(() => {
        if (selectedSensors.length === 0) return;

        const fetchDetections = async () => {
            try {
                const response = await getIOTDetections();
                setDetectionsList(response.data);
            } catch (error) {
                console.error("Error fetching detections:", error);
            }
        };

        fetchDetections();
    }, [selectedSensors]);

    const handleAdd = (detection) => {
        setSelectedDetections((prev) => [...prev, detection]);
        setDetections((prev) => [...prev, detection]); // Pass to parent state
        setDetectionsList((prev) => prev.filter((d) => d._id !== detection._id)); // Remove from list
    };

    const handleRemove = (index) => {
        const removedDetection = selectedDetections[index];
        setSelectedDetections((prev) => prev.filter((_, i) => i !== index));
        setDetectionsList((prev) => [...prev, removedDetection]); // Add back to list
    };

    const filteredDetections = detections.filter((detection) =>
        detection.detection_name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <Box>
            <Typography variant="h6">Select Detections</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
                Based on the selected sensors, choose detections to configure monitoring for specific events.
            </Typography>
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1">Selected Detections:</Typography>
                <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", mt: 1 }}>
                    {selectedDetections.map((detection, index) => (
                        <Chip
                            key={index}
                            label={`${detection.detection_name}`}
                            onDelete={() => handleRemove(index)}
                            sx={{ mb: 1 }}
                        />
                    ))}
                </Stack>
            </Box>
            <TextField
                label="Search Detections"
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ mb: 2 }}
            />
            <Box
                sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    p: 1,
                }}
            >
                <List>
                    {filteredDetections.map((detection) => (
                        <ListItem key={detection._id} alignItems="flex-start">
                            <ListItemAvatar>
                                <Avatar>{detection.detection_name.charAt(0)}</Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={<Typography variant="subtitle1">{detection.detection_name}</Typography>}
                                secondary={
                                    <>
                                        <Typography variant="body2" color="textSecondary">
                                            Applicable sensor: {detection.applicable_sensor}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Use cases: {detection.narrow_use_cases.join(", ")}
                                        </Typography>
                                    </>
                                }
                            />
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleAdd(detection)}
                            >
                                Add
                            </Button>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default DetectionSelection;
